import { jsx as _jsx } from "react/jsx-runtime";
import { Chip, Typography, useTheme } from '@mui/material';
import { DocumentProcessingStatus } from '../../../application/features/machine-documents/enums/document-processing-status';
import { MachineDocumentUploadingStatus } from '../../../application/features/machine-documents/enums/machine-document-uploading-status';
import useTranslate from '../../../localization/helpers';
var DocumentStatusTag = function (_a) {
    var uploadingStatus = _a.uploadingStatus, processingStatus = _a.processingStatus, addedToKnowledgeBase = _a.addedToKnowledgeBase, _b = _a.variant, variant = _b === void 0 ? 'text' : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c;
    var theme = useTheme();
    var translate = useTranslate().translate;
    // If added to knowledge base, don't show any status
    if (addedToKnowledgeBase) {
        return null;
    }
    // Determine the status to display
    var getStatusConfig = function () {
        // Uploading states
        if (uploadingStatus === MachineDocumentUploadingStatus.Pending) {
            return {
                text: variant === 'chip'
                    ? translate('knowledge.uploading')
                    : "".concat(translate('knowledge.uploading'), "..."),
                color: 'primary',
                themeColor: theme.palette.primary.main
            };
        }
        if (uploadingStatus === MachineDocumentUploadingStatus.Failed) {
            return {
                text: "".concat(translate('knowledge.uploadingFailed'), "! ").concat(translate('knowledge.pleaseRetry')),
                color: 'warning',
                themeColor: theme.palette.warning.main
            };
        }
        // Processing states (only if uploading succeeded)
        if (uploadingStatus === MachineDocumentUploadingStatus.Success) {
            if (processingStatus === DocumentProcessingStatus.NotProcessed) {
                return {
                    text: variant === 'chip'
                        ? translate('knowledge.processing')
                        : "".concat(translate('knowledge.processing'), "..."),
                    color: 'primary',
                    themeColor: theme.palette.primary.main
                };
            }
            if (processingStatus === DocumentProcessingStatus.RetryableFailure) {
                return {
                    text: "".concat(translate('knowledge.processingFailed'), "! ").concat(translate('knowledge.pleaseRetry')),
                    color: 'warning',
                    themeColor: theme.palette.warning.main
                };
            }
            // Non-retryable failure or other error states
            return {
                text: "".concat(translate('knowledge.unprocessable'), "!"),
                color: 'error',
                themeColor: theme.palette.error.main
            };
        }
        // Default fallback
        return null;
    };
    var statusConfig = getStatusConfig();
    if (!statusConfig) {
        return null;
    }
    // Render as Chip variant
    if (variant === 'chip') {
        return _jsx(Chip, { size: size, variant: 'soft', color: statusConfig.color, label: statusConfig.text });
    }
    // Render as Typography (default)
    return (_jsx(Typography, { variant: 'body2', sx: { color: statusConfig.themeColor }, children: statusConfig.text }));
};
export default DocumentStatusTag;
